export default __webpack_public_path__ + "static/media/MagicalStringsGroup.6b6afba4.jpg";